<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="money icon"></i>
      {{ $t("project payment") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img
          src="/images/icons/project_financial.jpg"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <generic-container
          icon="money"
          :title="$t('payment distribution')"
          :show_plus="true"
          @add="add_payment_distribution"
        >
          <div class="ui form">
            <div
              class="fields"
              v-for="(dist, idist) in distribution"
              :key="idist"
            >
              <div class="two wide disabled field">
                <label v-if="idist == 0">{{ $t("order") }}</label>
                <div class="ui input left icon">
                  <i class="hashtag icon"></i>
                  <input type="text" placeholder="" :value="idist + 1" />
                </div>
              </div>
              <div class="four wide field">
                <label v-if="idist == 0">{{ $t("concept") }}</label>
                <input
                  type="text"
                  placeholder=""
                  v-model="distribution[idist].concept"
                />
              </div>
              <div class="four wide field">
                <label v-if="idist == 0">{{ $t("date") }}</label>
                <div
                  class="ui calendar"
                  :data-idx="idist"
                  ref="payment_calendar"
                >
                  <div class="ui input left icon">
                    <i class="calendar icon"></i>
                    <input type="text" placeholder="" />
                  </div>
                </div>
                <!-- <input
                  type="text"
                  placeholder=""
                  v-model="distribution[idist].date"
                /> -->
              </div>
              <div class="three wide field">
                <label v-if="idist == 0">{{ $t("amount") }}</label>
                <div class="ui input left icon">
                  <i class="money icon"></i>
                  <input
                    type="text"
                    placeholder=""
                    v-model="distribution[idist].amount"
                  />
                </div>
              </div>
              <div class="two wide field">
                <label v-if="idist == 0">{{ $t("paid") }}</label>
                <div class="ui toggle checkbox" style="margin-top: 8px;">
                  <input
                    type="checkbox"
                    name=""
                    v-model="distribution[idist].paid"
                  />
                  <label></label>
                </div>
              </div>
            </div>
          </div>
          <!-- <pre>{{ distribution }}</pre> -->
        </generic-container>
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "ProjectPaymentModalIndex",
  components: { GenericContainer },
  props: {},
  computed: {},
  data() {
    return {
      uuid: "",
      distribution: [],
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        vm.uuid = data;
        local_api(vm, "post", "/project/payment/do-get-distribution", {
          u: data,
        })
          .then((dist) => {
            if (dist && dist.length > 0) {
              dist.map((d) => {
                vm.distribution.push({
                  uuid: d.uuid,
                  date: d.payment_date,
                  concept: d.concept,
                  amount: d.amount,
                  paid: d.paid,
                });
              });
            }
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {},
          onHide() {
            // vm.form.form("reset");
            vm.uuid = "";
            vm.distribution = [];
          },
        })
        .modal("show");

      // vm.form = window.jQuery(vm.$refs.form).form({
      //   fields: {
      //     name: ["empty"],
      //   },
      // });
    },
    save() {
      let vm = this;

      // let isValid = vm.form.form("validate form");
      // if (isValid) {
      local_api(vm, "post", "/project/payment/do-save", {
        u: vm.uuid,
        d: vm.distribution,
      })
        .then(() => {
          window.jQuery(vm.$refs.modal).modal("hide");
          vm.$emit("success");
        })
        .catch((err) => {
          error_toast(err);
        });
      // }
    },
    add_payment_distribution() {
      let vm = this;
      vm.distribution.push({
        uuid: "",
        date: "",
        concept: "",
        amount: "",
        paid: false,
      });
    },
  },
  mounted() {},
  watch: {
    distribution() {
      let vm = this;
      if (vm.distribution && vm.distribution.length > 0) {
        setTimeout(() => {
          window.jQuery(vm.$refs.payment_calendar).calendar({
            type: "date",
            onChange: function(value) {
              let idx = window.jQuery(this).data("idx");
              console.log("idx", idx);
              if (idx != undefined && idx != null) {
                console.log("setting value");
                vm.distribution[idx].date = value;
              }
              // console.log("date changed", value, this);
            },
          });
        }, 500);
      }
    },
  },
  updated: function() {},
};
</script>
